module.exports = __webpack_public_path__ + "static/12-86f7e22423e2fdb317d4575dee239f4a.jpeg";